import React, { useEffect } from 'react';
import { 
  FaUserCircle, 
  FaClipboardList, 
  FaMapMarkerAlt, 
  FaHeart, 
  FaLock, 
  FaSignOutAlt 
} from 'react-icons/fa';
import './Account.css';
import { useUser } from '../../store/UserContext';


function AccountP() {
  const {currentUser}=useUser()
  
  useEffect(()=>{
    
  },[currentUser])
  return (
    <div className="account-container">
      <div className="account-sidebar">
        <div className="account-header">
        <div >
            <img src="https://sp.yimg.com/ib/th/id/OIP.WjcaF01cijGxSrLoZuikxAHaHa?pid=Api&w=148&h=148&c=7&rs=1" 
            alt="" 
            className='account-avatar'/>
        </div>
      
          <div className="account-info">
            <h2>{currentUser.displayName}</h2>
            <p>Member since {currentUser.createdAt}</p>
          </div>
        </div>
        
        <ul className="account-menu">
          <li><a href="#" className="active"><FaUserCircle className="menu-icon" /> Profile</a></li>
          <li><a href="#"><FaClipboardList className="menu-icon" /> Orders</a></li>
          
          
          
          <li><a href="#"><FaSignOutAlt className="menu-icon" /> Logout</a></li>
        </ul>
      </div>
      
      <div className="account-content">
        <h2 className="account-section-title">Profile Information</h2>
        
        <div className="account-details">
          <div className="detail-group">
            <label>Full Name</label>
            <div className="detail-value">{currentUser.displayName}</div>
          </div>
          
          <div className="detail-group">
            <label>Email</label>
            <div className="detail-value">{currentUser.email}</div>
          </div>
          
          <div className="detail-group">
            <label>Phone Number</label>
            <div className="detail-value">{currentUser.phone}</div>
          </div>
          
         
          
          
          
         
        </div>
        
        <button className="edit-btn">Edit Profile</button>
        
        
      </div>
    </div>
  );
}

export default AccountP;